import React, { Component } from "react"
import ReactHighcharts from "react-highcharts"

const baseChart = {
  chart: {
    type: "bar",
    marginRight: 70
  },
  title: {
    text: null
  },
  tooltip: {
    headerFormat: "<span style='font-weight: bold;'>{point.key}</span><table>",
    pointFormat: "<tr><td style='padding:0'>{point.percentage}% das questões respondidas</td></tr>",
    footerFormat: "</table>",
    useHTML: true
  },
  plotOptions: {
    bar: {
      grouping: false,
      shadow: false,
      borderWidth: 1,
      dataLabels: {
        enabled: true
      }
    }
  },
  xAxis: {
    type: "category"
  },
  yAxis: {
    title: {
      text: null
    }
  }
}

class DailyMissionAnsweredChartPresentation extends Component {
  render () {
    const mergedChartConfig = Object.assign({}, baseChart, this.props.patch)

    return (
      <div>
        <ReactHighcharts config={mergedChartConfig} />
      </div>
    )
  }
}

export default DailyMissionAnsweredChartPresentation
